import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useEffect, useMemo, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { NATIVE_REDIRECT_URI } from "@/lib/nativeAuth";
import logoMark from "@/assets/logo-mark.png";
import { useSeo } from "@/lib/seo";

export const Route = createFileRoute("/auth/callback")({
  component: AuthCallbackPage,
});

function AuthCallbackPage() {
  useSeo({
    title: "Completing Your Sign-In | GreenTrack",
    description: "Finishing your GreenTrack sign-in and returning you to the app.",
    path: "/auth/callback",
  });
  const navigate = useNavigate();
  const [message, setMessage] = useState("Opening GreenTrack…");
  const deepLink = useMemo(() => {
    if (typeof window === "undefined") return NATIVE_REDIRECT_URI;
    return `${NATIVE_REDIRECT_URI}${window.location.search}${window.location.hash}`;
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const hash = window.location.hash || "";
    const search = window.location.search || "";
    const isRecovery = search.includes("mode=recovery") || hash.includes("type=recovery");

    if (hash || search.includes("code=") || isRecovery) {
      window.location.replace(deepLink);
      window.setTimeout(() => setMessage("Tap Open GreenTrack to continue."), 900);
      return;
    }

    supabase.auth.getSession().then(({ data }) => {
      if (data.session) navigate({ to: "/app", replace: true });
      else setMessage("Return to GreenTrack to continue.");
    });
  }, [deepLink, navigate]);

  return (
    <div className="min-h-screen w-full bg-paper text-ink flex items-center justify-center p-6">
      <div className="w-full max-w-sm space-y-6 text-center">
        <img src={logoMark} alt="GreenTrack" className="mx-auto h-20 w-auto object-contain" />
        <h1 className="font-display text-xl font-bold text-ink-deep">Completing your sign-in</h1>
        <p className="text-sm text-ink-muted">{message}</p>
        <a
          href={deepLink}
          className="inline-flex w-full items-center justify-center bg-ink-deep px-6 py-4 text-sm font-bold uppercase tracking-widest text-paper"
        >
          Open GreenTrack
        </a>
        <Link to="/auth" className="block text-xs text-ink-muted underline underline-offset-2">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}